import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ArthaGateway from 'service/ArthaGateway';
import { CreditNote, Sale, SaleOrder, BankCheque, VoucherSummary, Party } from 'service';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { faCalendar, faCircleCheck, faInr, faMoneyCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { durations } from 'service/Utils';

export const BankCheques = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [party, setParty] = useState<Party>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [durationId, setDurationId] = useState<string>(moment().month() > 3 ? moment().year().toString() : moment().subtract(1, 'year').year().toString());
    const [bankCheques, setbankCheques] = useState<BankCheque[]>([]);

    const chequeStatuses = [
        { id: '1', name: 'Pending', className: 'bg-secondary' },
        { id: '2', name: 'Post Dated', className: 'bg-dark' },
        { id: '3', name: 'Submitted', className: 'bg-info' },
        { id: '4', name: 'Cleared', className: 'bg-success' },
        { id: '5', name: 'Returned', className: 'bg-danger' }
    ];

    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
            setIsLoading(false);
        }
    }, [user]);

    useEffect(() => {
        loadbankCheques();
    }, [party]);

    useEffect(() => {
        setbankCheques([]);

        // loadbankChequesSummary();
        loadbankCheques();
    }, [durationId]);

    const loadbankCheques = () => {
        if (!party || !party.id || party.id <= 0) {
            return;
        }
        setIsLoading(true);
        ArthaGateway
            .getBankCheques(party?.id, durationId, 0)
            .then((data) => {
                setbankCheques(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
                setbankCheques([]);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page-bankCheques'>
            <div className="row">
                <div className="col-md-12">
                    <div className="card bg-dark text-white mb-2">
                        <div className="card-header">
                            <h2 className="fw-bold mb-4">Bank Cheques</h2>
                            <div>
                                <select className="form-control" id="duration" value={durationId} onChange={(e) => setDurationId(e.target.value)}>
                                    {durations.map((duration) => (
                                        <option key={duration.value} value={duration.value}>{duration.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className='col-12 cold-md-6 col-lg-4'>
                            {isLoading &&
                                <div className="text-center" style={{ padding: 20 }}>
                                    <div className="spinner-border text-dark" role="status">
                                    </div>
                                </div>
                            }
                            {bankCheques.length === 0 && !isLoading &&
                                <div className="alert alert-danger text-center" style={{ margin: 10 }}>
                                    No bank cheques found
                                </div>
                            }
                            {bankCheques && bankCheques.map((bankCheque) => (
                                <div className='card my-2' key={bankCheque.id}>
                                    <div className="card-header text-center">
                                        <h2 className="fw-bold">{bankCheque.chequeNumber}</h2>
                                    </div>
                                    <div className="card-body p-0">
                                        <table className="table table-sm mb-0">
                                            <tbody>
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faCalendar} />
                                                    </td>
                                                    <td>
                                                        Date:
                                                        <div className="fw-bold">{moment(bankCheque.chequeDate).format("DD MMM YYYY")}</div>
                                                    </td>
                                                </tr>
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faMoneyCheck} />
                                                    </td>
                                                    <td>
                                                        Cheque Number:
                                                        <div className="fw-bold">{bankCheque.chequeNumber}</div>
                                                    </td>
                                                </tr>
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faCircleCheck} />
                                                    </td>
                                                    <td>
                                                        Status:<br />
                                                        <div className={`badge ${chequeStatuses.find(status => status.id === bankCheque.status.toString())?.className} mx-2`}>
                                                            {chequeStatuses.find(status => status.id === bankCheque.status.toString())?.name}
                                                        </div>
                                                    </td>
                                                </tr>
                                                {bankCheque.status.toString() === '4' &&
                                                    <tr className="align-middle">
                                                        <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Cleared On:
                                                            <div className="fw-bold">{moment(bankCheque.clearedOn).format("DD MMM YYYY")}</div>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faInr} />
                                                    </td>
                                                    <td>
                                                        Amount:
                                                        <div className="fw-bold">{currencyFormat(bankCheque.amount)}/-</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="card-footer">
                                        {/*<div className="btn btn-dark w-100" title="View" onClick={() => viewbankChequeData(bankCheque)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; Download bankCheque
                                        </div>*/}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="card-footer">
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};